import { constants } from "redux/constants/redux-constants";

const initialState = {
  status: 'idle', // idle | uploading | polling | completed | error
  message: '',
  progress: 0,
  step: 0,
  totalSteps: 3,
  pollURL: null,
  result: null,
  error: null,
};

const PIAKnowledgeBasedReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.PIA_KNOWLEDGEBASED.UPLOAD_START:
      return {
        ...initialState,
        status: 'uploading',
      };

    case constants.PIA_KNOWLEDGEBASED.UPLOAD_SUCCESS:
      return {
        ...state,
        status: 'polling',
        pollURL: action.payload?.poll || '/pipeline/status',
        progress: 100,
      };

    case constants.PIA_KNOWLEDGEBASED.UPLOAD_FAILURE:
      return {
        ...state,
        status: 'error',
        error: action.error || action.payload,
      };

    case constants.PIA_KNOWLEDGEBASED.POLL_STATUS:
      return {
        ...state,
        status: 'polling',
        message: action.payload?.message || state.message,
        step: action.payload?.step || state.step,
        totalSteps: action.payload?.totalSteps || state.totalSteps,
      };

    case constants.PIA_KNOWLEDGEBASED.POLL_COMPLETE:
      return {
        ...state,
        status: 'completed',
        result: action.payload,
        message: action.payload?.message || 'completed',
      };

    case constants.PIA_KNOWLEDGEBASED.POLL_ERROR:
      return {
        ...state,
        status: 'error',
        error: action.error || action.payload,
      };

    case constants.PIA_KNOWLEDGEBASED.RESET:
      return initialState;

    case constants.PIA_KNOWLEDGEBASED.STATUS_UPDATE:
      return {
        ...state,
        status: action.payload.status,
        message: action.payload.message,
        step: action.payload.step || state.step,
        totalSteps: action.payload.totalSteps || state.totalSteps,
      };

    default:
      return state;
  }
};

export default PIAKnowledgeBasedReducer;
